import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CircularProgress from '../circularProgress/CircularProgress';
import FaCaretDown from 'react-icons/lib/fa/caret-down';
import './button.scss';
import classnames from 'classnames'

const BaseButton = (props) => {
    const {processing, label, icon, tooltipText, handleArrowOpen, isArrowOpen, showArrow, ...rest} = props;
    const buttonClasses = classnames({
        'base-button' : true,
        'processing' : processing
    })

    const arrowButtonClasses = classnames({
        'button-arrow' : true,
        'active' : isArrowOpen
    })

    return (
        <Button classes={{root: buttonClasses}} {...rest}>
            {icon && !processing && icon}
            {processing
                ? <CircularProgress colorType="whiteLoader" size={25} thickness={5}/>
                : <div className='button-label'>{label}</div> 
            }
            {tooltipText && <div className="button-tooltip">{tooltipText}</div>}
            {showArrow && <div onClick={handleArrowOpen} className={arrowButtonClasses}><FaCaretDown/></div>}
        </Button>
    );
};

BaseButton.propTypes = {
    processing: PropTypes.bool
};

export default BaseButton;
